import React, { FC } from "react";
import { IconType } from "./types";

export const CSCentreIcon: FC<IconType> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path
      d="M19 1.70874H5C3.89 1.70874 3 2.60874 3 3.70874V17.7087C3 18.8087 3.9 19.7087 5 19.7087H9L11.29 21.9987C11.68 22.3887 12.31 22.3887 12.7 21.9987L15 19.7087H19C20.1 19.7087 21 18.8087 21 17.7087V3.70874C21 2.60874 20.1 1.70874 19 1.70874ZM13 17.7087H11V15.7087H13V17.7087ZM15.07 9.95874L14.17 10.8787C13.59 11.4687 13.18 11.9787 13.05 12.9387C12.99 13.3687 12.64 13.6987 12.2 13.6987H11.89C11.37 13.6987 10.97 13.2387 11.04 12.7187C11.15 11.8087 11.57 10.9987 12.18 10.3787L13.42 9.11874C13.78 8.75874 14 8.25874 14 7.70874C14 6.60874 13.1 5.70874 12 5.70874C11.13 5.70874 10.38 6.27874 10.11 7.05874C9.98 7.42874 9.67 7.69874 9.28 7.69874H8.98C8.4 7.69874 8 7.13874 8.16 6.57874C8.65 4.91874 10.18 3.70874 12 3.70874C14.21 3.70874 16 5.49874 16 7.70874C16 8.58874 15.64 9.38874 15.07 9.95874Z"
      fill="white"
    />
  </svg>
);
